/* =========================================================================
   Workshop — product-form.js
   Variant selection: updates price, availability, URL, hidden id, media.
   Reads variant data from a JSON <script> in the product section.
   ========================================================================= */
(function () {
  'use strict';

  class ProductForm {
    constructor(root) {
      this.root = root;
      this.dataEl = root.querySelector('[data-variant-json]');
      if (!this.dataEl) return;
      this.variants = JSON.parse(this.dataEl.textContent);
      this.form = root.querySelector('form[data-product-form]');
      this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
      this.priceTarget = root.querySelector('[data-price-target]');
      this.addBtn = root.querySelector('[data-add-button]');
      this.addBtnText = this.addBtn ? this.addBtn.querySelector('[data-add-text]') : null;
      this.optionSelectors = Array.from(root.querySelectorAll('[data-option-selector]'));
      this.updateUrl = root.hasAttribute('data-update-url');

      this.optionSelectors.forEach((el) => el.addEventListener('change', () => this.onChange()));
      this.onChange(true);
    }

    selectedOptions() {
      // Group by option position; supports both radios and selects
      const values = [];
      const groups = {};
      this.optionSelectors.forEach((el) => {
        const pos = el.getAttribute('data-option-position');
        if (el.type === 'radio') {
          if (el.checked) groups[pos] = el.value;
        } else {
          groups[pos] = el.value;
        }
      });
      Object.keys(groups).sort().forEach((k) => values.push(groups[k]));
      return values;
    }

    findVariant() {
      const selected = this.selectedOptions();
      return this.variants.find((v) =>
        v.options.every((opt, i) => opt === selected[i])
      );
    }

    onChange(initial) {
      const variant = this.findVariant();
      this.currentVariant = variant;

      if (!variant) {
        this.setUnavailable();
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;

      if (this.priceTarget && variant.priceHtml !== undefined) {
        this.priceTarget.innerHTML = variant.priceHtml;
      }

      this.updateButton(variant);
      this.updateMedia(variant);

      if (this.updateUrl && !initial && variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.root.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    }

    updateButton(variant) {
      if (!this.addBtn) return;
      const available = variant && variant.available;
      this.addBtn.disabled = !available;
      if (this.addBtnText) {
        this.addBtnText.textContent = available
          ? (window.theme.strings.addToCart || 'Add to cart')
          : (window.theme.strings.soldOut || 'Sold out');
      }
    }

    setUnavailable() {
      if (this.addBtn) {
        this.addBtn.disabled = true;
        if (this.addBtnText) this.addBtnText.textContent = 'Unavailable';
      }
    }

    updateMedia(variant) {
      if (!variant || variant.featured_media_id == null) return;
      const gallery = this.root.querySelector('[data-media-gallery]');
      if (!gallery) return;
      const target = gallery.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
      if (!target) return;
      const main = gallery.querySelector('[data-media-main]');
      if (main) {
        gallery.querySelectorAll('[data-media-main] [data-media-item]').forEach((m) => m.classList.remove('is-active'));
        const mainItem = main.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
        if (mainItem) {
          mainItem.classList.add('is-active');
          mainItem.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach((el) => {
      if (!el._productForm) el._productForm = new ProductForm(el);
    });
  }
  initAll();

  // Thumbnail clicks
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    const id = thumb.getAttribute('data-media-thumb');
    const gallery = thumb.closest('[data-media-gallery]');
    if (!gallery) return;
    gallery.querySelectorAll('[data-media-item]').forEach((m) => m.classList.toggle('is-active', m.getAttribute('data-media-id') === id));
    gallery.querySelectorAll('[data-media-thumb]').forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
    const main = gallery.querySelector(`[data-media-main] [data-media-id="${id}"]`);
    if (main) main.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  }
})();
